/*
 * @Author: your name
 * @Date: 2020-07-17 16:47:13
 * @LastEditTime: 2020-10-23 12:41:14
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Web\JiYun.Mobile\src\views\salesTerminal\orderSituation\orderList\index.js
 */
import Base from '@/Base/index';

export default class extends Base {
    getOrderList() {
        let url = '';
        if (this.vm.isLeader) {
            url = '/interfaceApi/production/producttask/get_order_progress_leader';
        } else {
            url = '/interfaceApi/production/producttask/get_order_progress';
        }
        const queryStr = '?keywords=' + this.vm.keywords + '&pageindex=' + this.vm.page.pageindex + '&pagesize=' + this.vm.page.pagesize
            + '&product_status=' + this.vm.status + '&station_code=' + this.vm.station_code;
        return this.vm.$axios.$get(url + queryStr, { defEx: true });
    }
}
